<template>
  <!-- 线上 -->
  <Modal v-model="visible" title="保单详情" :footer-hide="true" width="1200" class="my-modal p-d top" id="myModal">
    <Tabs v-model="labelName" :animated="false">
      <TabPane label="投保信息" name="1">
        <orderInfo :detailData="detailInfo"></orderInfo>
      </TabPane>
      <TabPane label="被保险人及保障权益" name="2">
        <interests :obj="detailInfo" />
      </TabPane>
      <TabPane label="服务费信息" name="3" v-if="detailInfo.isGift != 1">
        <serveInfoNew :obj="detailInfo" />
      </TabPane>
      <!-- <TabPane label="续期信息" name="3">
          <renewal :obj="detailInfo" />
        </TabPane>
        <TabPane label="结算记录" name="4">
          <record />
        </TabPane>-->
    </Tabs>
  </Modal>
</template>
  
<script>
import interests from "./interests";
import serveInfoNew from "./serveInfoNew";
import orderInfo from "./orderInfo";
export default {
  components: {
    orderInfo,
    interests,
    serveInfoNew
  },
  props: [],
  data() {
    return {
      labelName: '1',
      visible: false,
      formData: {},//传入参数
      detailInfo: {}//详情数据
    };
  },
  computed: {
  },
  created() { },
  methods: {
    open(data = {}) {
      this.labelName = '1';
      this.formData = JSON.parse(JSON.stringify(data));
      this.getDetailData();
    },
    getDetailData() {
      this.$notice.showLoading();
      this.$http({
        url: "/buz/policy/read/detail",
        type: "GET",
        data: {
          policyNo: this.formData.policyNo
        }
      }).then(res => {
        const detailInfo = res.data;
        detailInfo.orgName = res.data.organizationName;
        detailInfo.groupName = res.data.groupName;
        detailInfo.salesmanName = res.data.agentName;
        this.detailInfo = detailInfo;
        this.visible = true;
      }).finally(res => {
        this.$notice.hideLoading();
      });
    }
  },

};
</script>
<style lang="scss" scoped>
#myModal {
  /deep/ {
    .page-form {
      padding-top: 1px !important;
    }

    .form-title {
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }
}
</style>
  